"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.toUUID = void 0;
const uuid_1 = require("uuid");
const namespaceUUID = '711d9fa6-e054-11ea-87d0-0242ac130003';
function toUUID(...seed) {
    return (0, uuid_1.v5)(seed.join('_'), namespaceUUID);
}
exports.toUUID = toUUID;
